import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Shared chrome for the pre-auth pages (login, register, reset-password): the
 * riverbed→starlight gradient background, centered flip* logo row, rounded
 * content panel, and bottom hero image. Each page projects its own heading/
 * form/links into the panel via the default content slot.
 */
@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {
  /** Set to false to drop the panel's background/shadow/radius, keeping only its width/padding. */
  @Input() panelBackground = true;
}
